<template>

  <div class="user">
    <!--添加任务-->
    <div class="common-seach-wrap">
      <el-form :inline="true" size="small" :model="formInline" class="demo-form-inline">
        <el-form-item label="报损报溢名称">
          <el-input placeholder="请输入报损报溢名称" v-model="formInline.search">
        
          </el-input>
        </el-form-item>
        <el-form-item >
          <el-button type="primary" icon="el-icon-search" @click="getData">查询</el-button>
        </el-form-item>

      </el-form>
    </div>


    <div class="product-content">
      <el-form ref="form" :model="form" label-width="100px">
        <div class="table-wrap">
          <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
            <!-- 商品编号 -->
            <el-table-column prop="product_id" label="商品编号"></el-table-column>
            
            <!-- 仓库编号 -->
            <el-table-column prop="warehouse_kw_id" label="仓库编号" width="60" ></el-table-column>

            <el-table-column prop="productName" label="产品名称" />
          <el-table-column prop="productCategory" label="产品分类" />
          <el-table-column prop="productSpecification" label="规格" />
          <el-table-column prop="salesUnit" label="单位" width="60" />
          <el-table-column prop="warehousekwtext" label="库位" />

          <el-table-column prop="purchasePrice" label="进货价"  width="60" />
          <el-table-column prop="product_price" label="销售价"  width="60" />
            
            <!-- 理论库存 -->
            <el-table-column prop="theoretical_qty" label="理论库存">
              <template #default="scope">
                {{ scope.row.rk_stock - scope.row.ck_stock }}
              </template>

            </el-table-column>

            <el-table-column prop="purchasePrice" label="进货总金额"  width="60" >
              <template slot-scope="scope">
                <div> 

                  {{ (scope.row.rk_stock *  scope.row.purchasePrice).toFixed(2)}}
                </div>
            </template>
            </el-table-column>
            
            <!-- 实际库存 -->
            <el-table-column prop="act_num" label="线下实际库存"></el-table-column>

            <el-table-column prop="actual_price" label="线下实际进货价">
            </el-table-column>
            
            <!-- 差异 -->
            <el-table-column prop="difference" label="差异数量" />
            <el-table-column prop="difference_price" label="差异金额"></el-table-column>
            
            <!-- 入库库存 -->
            <el-table-column prop="rk_stock" label="入库库存"></el-table-column>
            
            <!-- 出库库存 -->
            <el-table-column prop="ck_stock" label="出库库存"></el-table-column>
            
            <!-- 类型 -->
            <el-table-column prop="type" label="类型">
              <template #default="scope">
                <span v-if="scope.row.type === 1">库存报损</span>
                <span v-else-if="scope.row.type === 2">库存报溢</span>
              </template>
            </el-table-column>

                    <!-- 类型 -->
                    <el-table-column prop="type" label="类型">
              <template #default="scope">
                <span v-if="scope.row.price_type === 1">金额报损</span>
                <span v-else-if="scope.row.price_type === 2">金额报溢</span>
              </template>
            </el-table-column>
            
            <!-- 备注 -->
            <el-table-column prop="remark" label="备注">
            </el-table-column>
            <el-table-column prop="shop_user_text" label="操作人" />
            <el-table-column fixed="right" label="操作" width="50">
              <template slot-scope="scope">
  
                <el-button @click="deleteClick(scope.row)" type="text" size="small">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>
    
    <Add :open_add="open_add" v-if="open_add"   @close="closeAdd"></Add>
    <Edit :open_add="open_edit" :rlare_id="rlare_id"  v-if="open_edit"   @close="closeEdit"></Edit>

    <el-dialog  style="text-align: center" title="设置标题" :visible.sync="dialogVisible" @close='dialogFormVisible' 
    :close-on-click-modal="false" 
               :close-on-press-escape="false" :append-to-body="true">
    </el-dialog>
  
  </div>
</template>

<script>
  import RlareApi from '@/api/rlare.js';
  import Add from './part/add.vue';
  import Edit from './part/edit.vue';

  export default {
    components: {
      Add,
      Edit,
    },
    inject: ['reload'],
    data() {
      return {
        /*是否加载完成*/
        loading: true,
        /*列表数据*/
        tableData: [],
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*搜索表单对象*/
        form: {},
        formInline: {
          search:""
        },

        open_add:false,
        open_edit:false,
        rlare_id:"",
        dialogVisible:false,
      };
    },
    created() {

      /*获取列表*/
      this.getTableList();
    },
    methods: {
      dialogFormVisible(){
        this.dialogVisible = false;
      },
      setting(e){//报损报溢标题设置
        // this.categorya_id = e
        this.dialogVisible = true;
      },
       /*关闭添加*/
    closeAdd(e){
      this.open_add=false;
      this.getTableList();
    },
    closeEdit(e){
      this.open_edit=false;
      this.getTableList();
    },
    getData(){
      this.getTableList();
    },
      /*选择第几页*/
      handleCurrentChange(val) {
        this.curPage = val;
        this.getTableList();
      },

      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getTableList();
      },

      /*获取列表*/
      getTableList() {
        let self = this;
        let Params = this.formInline;
        Params.page = self.curPage;
        Params.list_rows = self.pageSize;
        self.loading = true;
        RlareApi.list(Params, true)
          .then(data => {
            self.loading = false;
            self.tableData = data.data.list.data;
            self.totalDataNumber = data.data.list.total;
          })
          .catch(error => {
          });
      },

      /*搜索查询*/
      onSubmit() {
        this.curPage = 1;
        this.getTableList();
      },

      /*添加任务*/
      addClick() {
        this.open_add = true
      },

      /*编辑活动*/
      editClick(row) {
        this.rlare_id = row.rlare_id;
        this.open_edit = true
      },

      /*删除*/
      deleteClick(row) {
        let self = this;
        self
          .$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            RlareApi.del(
              {
                rlare_id: row.rlare_id
              },
              true
            )
              .then(data => {
                if (data.code == 1) {
                  self.$message({
                    message: '删除成功',
                    type: 'success'
                  });
                  this.getTableList();
                } else {
                  self.$message.error('错了哦，这是一条错误消息');
                }
              })
              .catch(error => {
              });
          })
          .catch(() => {
          });
      }
    }
  };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/rlare/index/index.vue